module.exports = __webpack_public_path__ + "img/vue3-web3-3.9ec593f4.jpg";